<h2 mat-dialog-title class="mat-dialog-title-offset">{{ operationDescription }} Learning Section</h2>

<div class="modal-close-icon-container tw:flex tw:items-center">
  <button class="close-modal" mat-button [mat-dialog-close]="changesMade" tabindex='-1'>
    <div class="close-modal modal-close-icon"></div>
  </button>
</div>

<mat-dialog-content class="mat-typography modal-master-container">
  <div class="tw:py-12 content-container">
    @if (!data.timelineSection) {
      <div>
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
          <div class="tw:flex-1 tw:px-[15px] font-17 tag-list tw:flex tw:justify-center tw:mb-4">
            @for (name of groupStudentsNameList.split(', '); track name) {
              <div class="tag">
                {{name}}
              </div>
            }
          </div>
        </div>
        <p class="tl-section__prompt">Select one of the following learning sections to add to the timeline.</p>
        <ul class="tl-learning-sections tl-learning-sections--on-white">
          @for (section of learningSections; track section) {
            <li [ngClass]="getClass(section.sectionType)" class="tl-ls__tile" (click)="sectionClicked(section.sectionType)">
              <div class="tl-ls__tile-text-container">
                {{section.sectionType}}
                <label class="font-12 font-slategrey">
                  {{ section.sectionDescription }}
                </label>
              </div>
            </li>
          }
        </ul>
      </div>
    }
    @if (data.timelineSection) {
      <div>
        <h2 class="section__title">{{sectionTitle}}</h2>
        @if (data.editMode) {
          <div>
            <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
              <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2">
                <label class="field__label">
                  Section Date:@if (showDateMandatoryLabel()) {
                  <i class="tw:text-danger font-10">(mandatory)</i>
                  }
                </label>
                <input type="date" class="field__control tw:w-full" [disabled]="!isFormEditable()"
                  [(ngModel)]="data.timelineSection.sectionDate" [ngModelOptions]="{standalone: true}"
                  #input="ngModel" [min]="minSectionDate | date:'yyyy-MM-dd'">
                @if (input.value && minSectionDate && input.value < minSectionDate) {
                  <span class="field__error">Cannot add sections before {{ minSectionDate | date: 'dd MMM yyyy'}}</span>
                }
            </div>
          </div>
        </div>
      }
    </div>
  }
  <ng-template *timelineSectionSelector="data.timelineSection"></ng-template>
</div>
</mat-dialog-content>

<mat-dialog-actions class="div-flex-buttons">
  <div class="tw:flex tw:flex-wrap tw:p-0 tw:py-4 tw:m-0 tw:w-full">
    <div class="tw:w-full tw:p-0 tw:m-0">
      <button mat-button [mat-dialog-close]="changesMade" class="btn btn-primary tw:mx-1 learning-section-close-btn">Close</button>
      @if (showFormControls()) {
        <span>
          @if (saveButtonEnabled()) {
            <button type="button" class="btn btn-primary tw:mx-1 tw:float-right" (click)="save()">Save</button>
          }
          @if (deleteButtonEnabled()) {
            <button type="button" class="btn btn-primary tw:mx-1 tw:float-right" (click)="delete()">Delete</button>
          }
          @if (submitButtonEnabled()) {
            <button type="button" class="btn btn-primary tw:mx-1 tw:float-right" (click)="submit()">Submit</button>
          }
          @if (approveButtonEnabled()) {
            <button type="button" class="btn btn-primary tw:mx-1 tw:float-right" (click)="approve()">Approve</button>
          }
          @if (rejectButtonEnabled()) {
            <button type="button" class="btn btn-primary tw:mx-1 tw:float-right" (click)="reject()">Reject</button>
          }
          @if (unlockButtonEnabled()) {
            <button type="button" class="btn btn-primary tw:mx-1 tw:float-right" (click)="unlock()">Unlock</button>
          }
        </span>
      }
    </div>
  </div>
</mat-dialog-actions>


